import React from 'react';
import PropTypes from 'prop-types';

const CompareTrayCtas = ({
  productsCount,
  ctasLabel,
  compareCtaLabel,
  clearCtaLabel,
  onOpenCompare,
  onClearCompare,
}) => (
  <section className='ken-compare__tray__bottom__ctas'>
    <span className='--label'>{ctasLabel}</span>
    <button
      type='button'
      className='ken-button--secondary--small --clear'
      onClick={onClearCompare}
    >
      {clearCtaLabel}
    </button>
    <button
      type='button'
      className='ken-button--primary--small --compare js-gtm-comparison-tool-loaded'
      disabled={productsCount < 2}
      onClick={onOpenCompare}
    >
      {compareCtaLabel}
    </button>
  </section>
);

CompareTrayCtas.propTypes = {
  productsCount: PropTypes.number.isRequired,
  ctasLabel: PropTypes.string.isRequired,
  compareCtaLabel: PropTypes.string.isRequired,
  clearCtaLabel: PropTypes.string.isRequired,
  onOpenCompare: PropTypes.func.isRequired,
  onClearCompare: PropTypes.func.isRequired,
};

CompareTrayCtas.defaultProps = {};

export default CompareTrayCtas;
